<template>
  <pict
    class="accept-image__image m-auto s:max-w-auto m:max-w-xs l:max-w-auto"
    block-name="connected-image"
    :default="imageProps.default"
    :sources="imageProps.sources"
    :alt="$t('alt')"
  />
</template>

<script>
import Pict from "@/shared/pict"

import imageL from "./images/accept.png"
import imageL2x from "./images/accept@2x.png"
import imageS from "./images/accept_s.png"
import imageS2x from "./images/accept_s@2x.png"
export default {
  name: "AcceptImage",
  components: {
    Pict
  },
  computed: {
    imageProps() {
      return {
        default: {
          src: imageL,
          srcset: {
            "2x": imageL2x
          }
        },
        sources: [
          {
            media: "s",
            src: imageS,
            srcset: {
              "2x": imageS2x
            }
          }
        ]
      }
    }
  },
  i18n: {
    messages: {
      en: {
        alt: "A person with long dark hair and wearing blue glasses and a yellow shirt striped with blue holds a mobile device with one hand and high-fives another person with long dark hair and fringe, wearing a blue shirt with white dots holding a yellow mobile device."
      },
      de: {
        alt: "Eine Person mit langen schwarzen Haaren, einer braunen Brille und einer gelb-blau gestreiften Bluse und eine Person mit langen schwarzen Haaren und einer blauen Bluse geben sich ein High-Five. Beide halten ihr Smartphone in der Hand."
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.accept-image {
  ::v-deep &__image {
    width: 100%;
  }
}
</style>
